import PerformanceTable from './PerformanceTable';

export default PerformanceTable;
